export const surpriseRanking = [
  {
    rank: 1,
    name: "黑糖脏脏包",
    category: "甜口",
    score: 9.6,
    reason: "黑糖香气在拆袋瞬间就出来，可可粉给得大方，甜度虽高却让人愿意为它单独再买。",
  },
  {
    rank: 2,
    name: "川香麻辣锅巴",
    category: "辣味",
    score: 9.4,
    reason: "麻与香的比例拿捏得当，脆度保持到最后一片，是试吃团返场次数最多的一款。",
  },
  {
    rank: 3,
    name: "海盐焦糖曲奇",
    category: "甜口",
    score: 9.1,
    reason: "微流心的状态很讨喜，海盐把甜味压了一下，整体不腻，冷吃热吃都好。",
  },
  {
    rank: 4,
    name: "蜂蜜黄油杏仁",
    category: "坚果",
    score: 8.8,
    reason: "小包装加分，蜂蜜黄油厚薄均匀，咸甜平衡，适合当随身口粮。",
  },
  {
    rank: 5,
    name: "咸蛋黄酥",
    category: "咸香",
    score: 8.5,
    reason: "酥皮与馅心的比例合适，咸蛋黄不齁不干，微波十秒后香气更集中。",
  },
  {
    rank: 6,
    name: "藤椒味薯片",
    category: "辣味",
    score: 8.2,
    reason: "清香型辣味，油感低，片形完整，适合不想吃太重口的时候。",
  },
];